// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProBadge":"bei_a bhp_rj bhp_rk bhp_vh bhp_eb bhp_vf bhp_gu bhp_kh"};